export const PASSKEY_LIFECYCLE_TELEMETRY_WAIT_MS = 2000;

export const waitForPasskeyLifecycleTelemetry = async (
  telemetryPromise: Promise<void>
): Promise<void> => {
  let timeoutId: number | undefined;

  try {
    await Promise.race([
      telemetryPromise.catch(() => undefined),
      new Promise<void>(resolve => {
        timeoutId = window.setTimeout(
          resolve,
          PASSKEY_LIFECYCLE_TELEMETRY_WAIT_MS
        );
      }),
    ]);
  } finally {
    if (timeoutId !== undefined) {
      window.clearTimeout(timeoutId);
    }
  }
};
